import CalcContainer from './CalcContainer'
import FullResultContainer from './FullResultContainer'
import LoanDuration from './LoanDuration'
import MobileCalcButton from './MobileCalcButton'
import MobileResultHead, { IValueRow } from './MobileResultHead'
import RepreInfo from './RepreInfo'
import ResultContainer from './ResultContainer'
import ResultRow from './ResultRow'
export { InputRow } from './InputRow'
export { FollowUpButtons } from './FollowUpButtons'
export { CalcView, ICalcComponent } from './CalcView'

export {
  MobileCalcButton,
  MobileResultHead,
  IValueRow,
  CalcContainer,
  ResultContainer,
  ResultRow,
  RepreInfo,
  FullResultContainer,
  LoanDuration,
}
